// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".language-select {\n  color: var(--primary-background-color);\n  display: block;\n  min-width: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
